module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "block",
    class: {
      'block_bold': _vm.bold
    }
  }, [_c('span', {
    staticClass: "block__name"
  }, [_vm._v(_vm._s(_vm.name) + ": ")]), _c(_vm.link ? 'a' : 'span', {
    tag: "component",
    staticClass: "block__text",
    attrs: {
      "href": _vm.link
    }
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bcdb2d4","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/cards/contract/components/infoblock/Infoblock.vue
// module id = 5bc6fdde09259bc5d5bb
// module chunks = 89